module.exports = __webpack_public_path__ + "img/destination-placeholder-img.ded48fd8.png";